import React, { Fragment } from "react";

import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  CssBaseline,
  Tabs,
  Tab,
} from "@mui/material";

import { ButtonExit } from "components/cardBodyStyle";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function FrequentQuestions(props) {
  const [valueTabs, setValueTabs] = React.useState(0);

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleChangeTabs = (event, newValue) => {
    setValueTabs(newValue);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent>
          <CssBaseline />
          <Box
            sx={{
              textAlign: "justify",
              background: "#FAFAFA",
              padding: 1,
              fontSize: 14,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={valueTabs}
                  onChange={handleChangeTabs}
                  aria-label="basic tabs example"
                  sx={{ background: "#F4F4F4" }}
                >
                  <Tab
                    label="ACEPTACIÓN DE TÉRMINOS Y CONDICIONES"
                    {...a11yProps(0)}
                    sx={{
                      fontSize: 12,
                      width: 260,
                      fontWeight: 500,
                      color: "#000",
                    }}
                  />
                  <Tab
                    label="PROTECCIÓN DE DATOS PERSONALES"
                    {...a11yProps(1)}
                    sx={{
                      fontSize: 12,
                      width: 260,
                      fontWeight: 500,
                      color: "#000",
                    }}
                  />
                  <Tab
                    label="PREGUNTAS FRECUENTES SOBRE PAGOS ELECTRÓNICOS"
                    {...a11yProps(2)}
                    sx={{
                      fontSize: 12,
                      width: 260,
                      fontWeight: 500,
                      color: "#000",
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={valueTabs} index={0}>
                <b>ACEPTACIÓN DE TÉRMINOS Y CONDICIONES</b>
                <br></br>
                <br></br>• Todo servicio deberá ser coordinado exclusivamente a
                través de la central de atención al cliente mediante los números
                telefónicos: +(593) 997055126 o +(593) 992580688, o a través de
                los correos:{" "}
                <b>
                  sistemas@vivetechecuador.com y clientes@vivetechecuador.com
                </b>{" "}
                Cualquier atención no autorizada o no registrada por dichos
                canales no contará con cobertura ni derecho a reembolso.
                <br></br>• La vigencia del servicio está sujeta al cumplimiento
                puntual de los pagos por parte del cliente, ya sea en modalidad
                de cuotas mensuales o pago total anticipado.
                <br></br>• No se cubrirán tratamientos odontológicos ya
                iniciados al momento de la contratación del servicio.
                <br></br>• El contrato podrá mantenerse vigente por hasta un
                máximo de sesenta (60) días en caso de mora, únicamente respecto
                de la relación contractual, no así respecto del servicio, el
                cual permanecerá suspendido hasta la regularización de los
                pagos.
                <br></br>• Tiempo de carencia: 30 días contados desde la fecha
                de activación del servicio de pagos en línea.
                <br></br>• No se cubrirán pagos procesados por canales externos
                ni servicios no autorizados por BookNPay.
                <br></br>• No se aceptarán solicitudes de reembolso por
                servicios no incluidos expresamente en los presentes términos.
                <br></br>• La adhesión al presente servicio es libre y
                voluntaria.
                <br></br>• El servicio de pagos en línea es prestado por{" "}
                <b>Vive Tech Ecuador S.A.S.</b>, en calidad de{" "}
                <b>Responsable del Tratamiento de Datos Personales</b>, conforme
                lo establecido en la Ley Orgánica de Protección de Datos
                Personales (LOPDP) y su reglamento.
                <br></br>• El cliente declara que los recursos económicos
                utilizados provienen de fuentes lícitas.
                <br></br>• El cliente declara haber sido debidamente informado
                sobre las condiciones, cobertura, costos, vigencia, límites y
                funcionamiento del servicio contratado.
                <br></br>• El presente contrato es válido en todo el territorio
                de la República del Ecuador.
                <br></br>• El titular del contrato deberá ser mayor de edad al
                momento de la firma del mismo.
                <br></br>• El titular es responsable de mantener sus datos
                actualizados, para efectos de notificación y comunicación.
                <br></br>• El presente contrato tiene una vigencia indefinida y
                se renovará automáticamente mientras el cliente se mantenga al
                día en sus obligaciones.
                <br></br>• El cliente podrá dar por terminado el presente
                contrato en cualquier momento, sin penalidad, mediante solicitud
                escrita dirigida a <b>Vive Tech Ecuador S.A.S.</b>, con una
                anticipación mínima de treinta (30) días calendario. Dicha
                solicitud deberá contener firma del titular, copia de cédula y
                ser enviada por canales oficiales.
                <br></br>• La terminación del contrato afectará automáticamente
                a todos los servicios activos en la cuenta, salvo que alguno de
                los usuarios asuma la titularidad conforme a los procedimientos
                establecidos por BookNPay. La empresa confirmará por escrito la
                finalización del contrato y el estado de cuenta en un plazo
                máximo de cinco (5) días hábiles desde la recepción válida de la
                solicitud.
                <br></br>• <b>Autorización de Débito Mensual:</b> El Cliente
                autoriza expresamente a Vive Tech Ecuador S.A.S. a debitar de
                forma automática los valores correspondientes a la suscripción
                del servicio contratado.
                <br></br>• Cualquier modificación en el valor del servicio será
                notificada previamente al cliente, quien tendrá la posibilidad
                de aceptar los nuevos términos o cancelar el servicio.
                <br></br>• La entrega de información falsa o inexacta por parte
                del cliente anulará automáticamente los derechos adquiridos y
                podrá implicar acciones legales por perjuicios ocasionados.
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={1}>
                <b>PROTECCIÓN DE DATOS PERSONALES</b>
                <br></br>
                <br></br>• De conformidad con la Ley Orgánica de Protección de
                Datos Personales, el cliente autoriza a{" "}
                <b>Vive Tech Ecuador S.A.S.</b> a utilizar sus datos conforme a
                las finalidades descritas en este contrato y en su política de
                privacidad.
                <br></br>• Los datos personales se recolectarán, almacenarán,
                procesarán, transmitirán y eliminarán de acuerdo con estándares
                internacionales de seguridad de la información, pudiendo
                alojarse dentro o fuera del territorio ecuatoriano.
                <br></br>• BookNPay se compromete a utilizar los datos
                personales únicamente para el cumplimiento del objeto
                contractual, y a eliminar dicha información una vez finalizado
                el servicio, conforme a la normativa vigente.
                <br></br>• Se reconoce el derecho de los titulares de datos
                personales conforme lo establecido por la LOPDP.
                <br></br>• La aceptación digital del presente contrato conlleva
                la aceptación expresa de la Política de Privacidad de BookNPay,
                así como la de Placetopay, proveedor de pasarela de pagos,
                disponible en: 🔗
                https://www.placetopay.com/web/politicas-de-privacidad/
                <br></br>
                <br></br>
                <b>
                  {" "}
                  Todos los derechos reservados – Vive Tech Ecuador S.A.S.
                  <br></br>RUC: 1793227185001
                  <br></br>Fecha de última actualización: 01-07-2025
                </b>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs} index={2}>
                <b>PREGUNTAS FRECUENTES SOBRE PAGOS ELECTRÓNICOS</b>
                <br></br>
                <br></br>
                En este documento, usted encontrará una sección de preguntas y
                respuestas que le ayudará a sus usuarios a aclarar sus dudas
                sobre los pagos electrónicos procesados a través de Placetopay.
                Recuerde que debe incluirlas en su sitio web.
                <br></br>
                <br></br>
                <b>1. ¿Qué es Placetopay? </b>
                Placetopay es la plataforma de pagos electrónicos que usa Vive
                Tech Ecuador S.A.S para procesar en línea las transacciones
                generadas en la tienda virtual con las formas de pago
                habilitadas para tal fin.
                <br></br>
                <br></br>
                <b>2. ¿Cómo puedo pagar? </b>
                En la tienda virtual de Vive Tech Ecuador S.A.S, usted podrá
                realizar su pago con los medios habilitados para tal fin. Usted,
                de acuerdo con las opciones de pago escogidas por el comercio,
                podrá pagar a través Diners, Discover, Visa y MasterCard; de
                todos los bancos con pago corriente y pagos diferidos,
                únicamente las tarjetas emitidas por Banco Pichincha, Diners,
                Loja, BGR y Manabí.
                <br></br>
                <br></br>
                <b>
                  3. ¿Es seguro ingresar mis datos bancarios en este sitio web?{" "}
                </b>
                Para proteger tus datos Vive Tech Ecuador S.A.S delega en
                Placetopay la captura de la información sensible. Nuestra
                plataforma de pagos cumple con los más altos estándares exigidos
                por la norma internacional PCI DSS de seguridad en transacciones
                con tarjeta de crédito. Además, tiene certificado de seguridad
                SSL expedido por GeoTrust una compañía Verisign, el cual
                garantiza comunicaciones seguras mediante la encriptación de
                todos los datos hacia y desde el sitio; de esta manera, te
                podrás sentir seguro a la hora de ingresar la información de su
                tarjeta.
                <br></br>
                <br></br>
                Durante el proceso de pago, en el navegador se muestra el nombre
                de la organización autenticada, la autoridad que lo certifica y
                la barra de dirección cambia a color verde. Estas
                características son visibles de inmediato y dan garantía y
                confianza para completar la transacción en Placetopay.
                <br></br>
                <br></br>
                Placetopay también cuenta con el monitoreo constante de McAfee
                Secure y la firma de mensajes electrónicos con Certicámara.
                <br></br>
                <br></br>
                Placetopay es una marca de la empresa colombiana EGM Ingeniería
                Sin Fronteras S.A.S.
                <br></br>
                <br></br>
                <b>
                  4. ¿Puedo realizar el pago cualquier día y a cualquier hora?{" "}
                </b>
                Sí, en Vive Tech Ecuador S.A.S. podrás realizar tus compras en
                línea los 7 días de la semana, las 24 horas del día a sólo un
                clic de distancia.
                <br></br>
                <br></br>
                <b>5. ¿Puedo cambiar la forma de pago?</b>
                Si aún no has finalizado tu pago, podrás volver al paso inicial
                y elegir la forma de pago que prefieras. Una vez finalizada la
                compra no es posible cambiar la forma de pago.
                <br></br>
                <br></br>
                <b>
                  6. ¿Pagar electrónicamente tiene algún valor para mí como
                  comprador?{" "}
                </b>
                No, los pagos electrónicos realizados a través de Placetopay no
                generan costos adicionales para el comprador.
                <br></br>
                <br></br>
                <b>7. ¿Qué debo hacer si mi transacción no concluyó?</b>
                En primera instancia deberás revisar si llegó un mail de
                confirmación del pago en tu cuenta de correo electrónico (la
                inscrita en el momento de realizar el pago), en caso de no
                haberlo recibido, deberás contactar a
                sistemas@vivetechecuador.com para confirmar el estado de la
                transacción.
                <br></br>
                <br></br>
                En caso de que tu transacción haya declinado, debes verificar si
                la información de la cuenta es válida, está habilitada para
                compras no presenciales y si tienes cupo o saldo disponible. Si
                después de esto continua con la declinación debes comunicarte
                con Vive Tech Ecuador S.A.S. . En última instancia, puedes
                remitir tu solicitud a servicioposventa@placetopay.ec.
                <br></br>
                <br></br>
                <b>8. ¿Qué debo hacer si no recibí el comprobante de pago?</b>
                Por cada transacción aprobada a través de Placetopay, recibirás
                un comprobante del pago con la referencia de compra en la
                dirección de correo electrónico que indicaste al momento de
                pagar. Si no lo recibes, podrás contactar a la línea +(593)
                992580688 o al correo electrónico sistemas@vivetechecuador.com,
                para solicitar el reenvío del comprobante a la misma dirección
                de correo electrónico registrada al momento de pagar. En última
                instancia, puedes remitir tu solicitud a
                servicioposventa@placetopay.ec.
                <br></br>
                <br></br>
                <b>9. No me llegó el producto que compré ¿qué hago?</b>
                Debes verificar si la transacción fue exitosa en tu extracto
                bancario. En caso de ser así, debes revisar nuestras políticas
                de envío en el sitio web
                https://www.placetopay.com/web/politicas-de-privacidad/ para
                identificar los tiempos de entrega.
              </CustomTabPanel>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
